import { get } from 'lodash';
import { modifyAlpha } from '../../../../../utils/modifyColour';

const styles = ({ color, fontWeight, theme, typography }) => ({
  categoryEntityRow: {
    fontFamily: get(typography, 'pageTitle'),
    fontWeight: get(fontWeight, 'bold'),
  },
  categoryWrapper: {
    backgroundColor: get(color, 'background'),
    marginLeft: -36,
    marginRight: -20,
    paddingBottom: 28,
  },
  container: {
    backgroundColor: get(color, 'uiBackground'),
    border: `2px solid ${get(color, 'background')}`,
    cursor: 'pointer',
  },
  errorTitle: {
    backgroundColor: modifyAlpha(get(color,'error'), 0.1),
  },
  iconRoot: {
    color: get(theme, 'color.primaryButtonBackground'),
  },
  infoContainer: {
    borderColor: get(color, 'attention'),
  },
  infoTitle: {
    backgroundColor: modifyAlpha(get(color,'warning'), 0.1),
  },
  errorContainer: {
    borderColor: get(color, 'error'),
  },
  entityRow: {
    borderTop: `1px solid ${get(color, 'grayBorder')}`,
    height: 40,
    lineHeight: '40px',
  },
  titleRow: {
    display: 'flex',
    height: 40,
    lineHeight: '40px',
    paddingLeft: 32,
  },
});

export default styles;
